import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { setGridView } from "../../../../../../redux/SearchSlice";
import { localStorageInstance } from "../../../../../../utils/localStorage";

export function useBoardViewToggle({
  searchParams,
  setSearchParams,
  setParamsWorklogs,
  setLoading,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();
  const gridView = useSelector((state) => state.search.gridView);
  const paramsWorklogs = searchParams.get("worklogs") || "false";

  const isBoardPath = location.pathname.includes("/board/");
  const currentSearch = searchParams.toString();
  const isGridActive =
    gridView && paramsWorklogs === "false" && isBoardPath;
  const isListActive =
    !gridView && paramsWorklogs === "false" && isBoardPath;

  const navigateToBoard = useCallback(() => {
    navigate(`/board/${id}${currentSearch ? `?${currentSearch}` : ""}`);
  }, [currentSearch, id, navigate]);

  const handleGridClick = useCallback(() => {
    const nextSearchParams = new URLSearchParams(searchParams);
    nextSearchParams.delete("workflow_Step");
    setSearchParams(nextSearchParams);

    if (!gridView) {
      dispatch(setGridView());
    }

    setLoading(false);
    setParamsWorklogs("worklogs", "false");
    localStorageInstance.setItem({
      key: "showGridView",
      value: true,
    });

    if (!isBoardPath) {
      navigateToBoard();
    }
  }, [
    dispatch,
    gridView,
    isBoardPath,
    navigateToBoard,
    searchParams,
    setParamsWorklogs,
    setSearchParams,
  ]);

  const handleListClick = useCallback(() => {
    if (gridView) {
      dispatch(setGridView());
    }

    setLoading(true);
    setParamsWorklogs("worklogs", "false");
    localStorageInstance.setItem({
      key: "showGridView",
      value: false,
    });

    if (!isBoardPath) {
      navigateToBoard();
    }
  }, [
    dispatch,
    gridView,
    isBoardPath,
    navigateToBoard,
    setLoading,
    setParamsWorklogs,
  ]);

  return useMemo(
    () => ({
      handleGridClick,
      handleListClick,
      isGridActive,
      isListActive,
    }),
    [handleGridClick, handleListClick, isGridActive, isListActive]
  );
}
